// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1MXSz","filesListContainer":"PosDisputesFiles_filesListContainer__3z_G1","filesButton":"PosDisputesFiles_filesButton__2JPLC"};